import { SPIDER_API, apiCall } from './api';

export const triggerIngestion = (shopName: string, manufacturingCalculationType: string): Promise<void | null> => {
  if (!shopName) return Promise.resolve(null);
  return apiCall('POST', `${SPIDER_API}/process-store`, {
    store_domain: shopName,
    manufacturing_calculation_type: manufacturingCalculationType
  });
};
